import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Input, OnDestroy } from '@angular/core';
import { AppServerAPI, ServiceResponse } from '@sdbn/common';
import { Subscription } from 'rxjs';

import { Station } from '../../../../../client/model/station';
import { CompletionOption, StationUsage, TransportCreationProfile } from '../../../../../client/model/station-usage.model';
import { TransportDetailsLayoutConverter } from '../../../../../common/components/tmp/transport-details-layout-converter.service';
import { TransportDetailLayout, TransportDetailMode } from '../../../../../common/configuration/transport.configuration';
import { Transport, TransportType } from '../../../../../common/model/transport.model';
import { TransportDetailsLayoutService } from '../../../../../components/transport-details/transport-details-layout.service';
import { StationDetailsView } from '../../model/action-tablet.model';

@Component({
  selector: 'app-action-tablet-station-details',
  templateUrl: './action-tablet-station-details.component.html',
  styleUrls: ['./action-tablet-station-details.component.scss']
})
export class ActionTabletStationDetailsComponent implements OnDestroy {

  isLoading = false;

  tmcContextSubscription: Subscription;

  stationId: number;
  station: Station;

  stationDisabled = false;
  transportDetails: Transport;
  defaultCompletionOption: CompletionOption;
  transportCreationProfiles: Array<TransportCreationProfile>;
  showTransportDetails = false;
  showHeader = false;

  stationDetailsViewValues = StationDetailsView;
  stationDetailsView: StationDetailsView;

  TransportDetailMode = TransportDetailMode;
  layoutDefinition: TransportDetailLayout;

  @Input("stationId") set setStationExternalKey(stationId: number) {
    this.stationId = stationId;
    this.updateModels();
  }

  constructor(
    private tmcContextService: TmcContextService,
    private appServerAPI: AppServerAPI,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    private transportDetailsLayoutConverter: TransportDetailsLayoutConverter,
  ) {
    this.tmcContextSubscription = this.tmcContextService.stationUsagesUpdated$.subscribe(() => this.updateModels());

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createActionTabeletTransportDetailsGridLayout()
    );

  }

  ngOnDestroy(): void {
    if (this.tmcContextSubscription) {
      this.tmcContextSubscription.unsubscribe();
    }
  }

  private updateModels() {
    if (this.stationId != null) {
      this.station = this.tmcContextService.findStationById(this.stationId);
      if (this.station != null) {
        this.stationDisabled = this.station.stationUsage.disabled || this.station.stationUsage.suspended;
        this.transportDetails = this.station.stationUsage.transports[0];
        this.defaultCompletionOption = this.station.stationUsage.defaultCompletionOption;
        this.transportCreationProfiles = this.station.stationUsage.transportCreationProfiles.filter(r => r.actionTablet === true);

        this.stationDetailsView = this.calculateStationDetailsView(this.station.stationUsage);

      }
      this.showTransportDetails = this.transportDetails != null && (this.transportDetails.masterdata.transportType === TransportType.TRANSPORT
        || (this.station.stationUsage.ongoingMovementToStation));
        this.showHeader = this.transportDetails != null;
        console.log('----------', this.showHeader, this.showTransportDetails, this.transportDetails);
    } else {
      this.station = null;
      this.transportCreationProfiles = null;
      this.showTransportDetails = false;
      this.stationDisabled = true;
      this.stationDetailsView = StationDetailsView.STATION_DISABLED;
     }
  }

  calculateStationDetailsView(stationUsage: StationUsage): StationDetailsView {
    if (stationUsage.disabled ||stationUsage.suspended) {
      return StationDetailsView.STATION_DISABLED;
    } else if (stationUsage.ongoingMovementToStation) {
      return StationDetailsView.ONGOING_MOVEMENT_ORDER_TO_STATION;
    } else if (stationUsage.ongoingMovementFromStation) {
      return StationDetailsView.ONGOING_MOVEMENT_ORDER_FROM_STATION;
    } else if (!stationUsage.ongoingMovementFromStation && !stationUsage.ongoingMovementToStation) {
      return StationDetailsView.STATION_OCCUPIED;
    }
  }

  public endSuspension() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.appServerAPI.execute<ServiceResponse>('/client/control/action-tablet/end-station-suspension', { id: this.station.id })
      .subscribe(() => {
        this.tmcContextService.forceRefreshOfStationUsages();
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }

  public startSuspension() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.appServerAPI.execute<ServiceResponse>('/client/control/action-tablet/suspend-station', { id: this.station.id })
      .subscribe(() => {
        this.tmcContextService.forceRefreshOfStationUsages();
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      });
  }
}
